import { useState, useCallback, Dispatch, SetStateAction } from 'react'

const usePersistedPage = (key?: string): [number, Dispatch<SetStateAction<number>>] => {
  const [page, setPageState] = useState<number>(() => {
    if (key) {
      const stored = sessionStorage.getItem(key)
      if (stored !== null) {
        const parsed = parseInt(stored, 10)
        return Number.isNaN(parsed) || parsed < 0 ? 0 : parsed
      }
    }
    return 0
  })

  const setPage: Dispatch<SetStateAction<number>> = useCallback(
    value => {
      setPageState(prev => {
        const next = typeof value === 'function' ? value(prev) : value

        if (key) {
          sessionStorage.setItem(key, next.toString())
        }

        return next
      })
    },
    [key]
  )

  return [page, setPage]
}

export default usePersistedPage
